import { API_BASE_URL } from "../../Components/constants";
import { ensureFreshAccessToken } from "../http/axiosConfig";
import stomp from "./stompClient";

const stripTrailingSlash = (s) =>
  typeof s === "string" && s.endsWith("/") ? s.slice(0, -1) : s;

/**
 * 실시간 연결이 없으면 열고, 이미 있으면 그대로 쓴다.
 *
 * 드론 화면과 격자 셀 선택이 같은 연결을 쓴다. 예전에는 드론 화면만 연결을 열어서,
 * 드론이 없는 농장에서는 셀 선택이 실시간으로 오가지 못하고 새로고침해야 반영됐다.
 *
 * @returns 연결됐으면 true, 토큰이 없어 열지 못했으면 false
 */
export async function ensureStompConnected() {
  if (stomp.isConnected()) return true;

  await ensureFreshAccessToken();
  if (!localStorage.getItem("accessToken")) return false;

  const sameOrigin = `${window.location.protocol}//${window.location.host}`;
  const baseUrl = stripTrailingSlash(
    process.env.REACT_APP_WS_BASE_URL || API_BASE_URL || sameOrigin
  );

  stomp.configure({
    wsUrl: `${baseUrl}/ws`,
    connectHeaders: () => {
      const t = localStorage.getItem("accessToken");
      return t ? { Authorization: `Bearer ${t}` } : {};
    },
    // 재접속은 이 클라이언트가 아니라 훅이 관리한다. 둘 다 하면 접속이 두 번 뜬다.
    reconnectDelay: 0,
  });

  await stomp.connect();
  return true;
}

export default ensureStompConnected;
